import { hydrate } from "svelte";
import { experimental, islandsOptions, rootComponent } from "@kestrel/internal/client";
import type * as Module from "@kestrel/entry";
import { resolveComponentFromRouteId } from "../component/resolve.js";
import { createStores, updateCallback } from "../stores/index-universal.js";
import { noop } from "../../utils/function.js";
import {
  hydrateIslandsIfAllRegistered,
  propagateIslandsFromEntrypoint,
  registerIslandEntrypoint,
} from "../islands/islands.js";
import { createRootContext } from "../context/createRootContext.js";
import { goto } from "../stores/goto.js";
import { getNavigationTargetFromUrl } from "../stores/utils.js";
import { entryAppIdAttribute, serverDataMime } from "../../utils/consts.js";

/**
 *
 */
export const add = islandsOptions ? registerIslandEntrypoint : noop;

/**
 *
 *
 *
 *
 */
export const start = (async (current) => {
  const container = current.parentElement;
  if (import.meta.env.DEV && !container) {
    throw new Error("current script element is not attached to a parent");
  }

  const ssrStateScript = container!.querySelector<HTMLScriptElement>(
    `script[type='${serverDataMime}'][${entryAppIdAttribute}]`,
  );
  if (import.meta.env.DEV && !ssrStateScript) {
    throw new Error("No ssr state script found by entryAppIdAttribute");
  }

  const ssrStateJson = decodeURIComponent(ssrStateScript!.textContent);
  const ssrState = JSON.parse(ssrStateJson);

  if (import.meta.env.DEV && !ssrState.routeId && !ssrState.error) {
    throw new Error("Invalid ssr state, missing routeId");
  }

  /*                                              */
  const resolvedComponent = await resolveComponentFromRouteId(ssrState.routeId, ssrState.error);

  /*                                                */
  /*                                                             */
  const stores = createStores(ssrState, resolvedComponent);

  /*                                                                         */
  /*                      */
  if (experimental.useRenderMethod && !ssrState.error && !ssrState.dataReady) {
    const to = await getNavigationTargetFromUrl(stores, undefined);
    await goto(stores, {}, to, "goto", updateCallback);
  }

  /*                                                                              */
  if (islandsOptions) {
    propagateIslandsFromEntrypoint(current);
    hydrateIslandsIfAllRegistered(stores, ssrState, resolvedComponent);
  }
  /*                                                                                */
  else {
    hydrate(rootComponent, {
      target: container!,
      props: { component: resolvedComponent[0] },
      context: createRootContext(stores),
    });
  }

  /*                                        */
  current.remove();
}) satisfies typeof Module.start;
